export class UserDetail {
  constructor(props) {
    this.imageUrl = props.avatar;
    this.roles = props.roles;
    this.name = props.name;
  }
}
